/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect, useCallback } from "react";
import { GblContext } from "providers/formatter";
import { useStateWithCallbackLazy } from "use-state-with-callback";
import clsx from "clsx";
import { withStyles } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import { useRedirect, useTranslate } from "react-admin";
import EditIcon from "@material-ui/icons/Edit";
import { Box, Divider, Paper, Grid, Typography, Button } from "@material-ui/core";
import { TableFooter, TableRow, TableCell, Tabs, Tab, Tooltip } from "@material-ui/core";
import DimensionContent from "components/DimensionContent";
import NumberFormatInput from "components/NumberFormatInput";
import ActionMenu from "components/ActionMenu";
import BoxHeader from "components/BoxHeader";
import ButtonFooter from "components/ButtonFooter";
import NavRight from "components/NavRightSide";
import MUIDataTable from "mui-datatables";
import DialogChangeRevision from "./DialogChangeRevision";
import { createBudgetDetail } from "services/generalLedger";
import { getActiveDimListByModuleName } from "services/dimension";
import Model from "models/budget";
import { addDays, addYears } from "date-fns";
import SnackbarUtils from "utils/SnackbarUtils";
import { getYearListByYear } from "services/setting";
import { endOfMonth } from "date-fns/esm";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StyledTab = withStyles({
  root: {
    textTransform: "none",
  },
})((props) => <Tab {...props} />);

const Create = (props) => {
  const translate = useTranslate();
  const classes = props.useStyles();
  const { basePath, formFields } = props;
  const redirect = useRedirect();
  const [initData, setInitData] = useStateWithCallbackLazy(Model);
  const [dataTab1, setDataTab1] = useStateWithCallbackLazy();
  const [dataTab2, setDataTab2] = useStateWithCallbackLazy();
  const [value, setValue] = useState(0);
  const [openDialogChangeRev, setOpenDialogChangeRev] = useState(false);
  const [revNo, setRevNo] = useState(0);
  const { settingAll, DateToString, StringToDate, NumberFormat, ToNumber } = useContext(GblContext);
  const { SettingClosePeriod, SettingSystem } = settingAll;
  const { ClosePeriodGl } = SettingClosePeriod;
  const [isBtnLoading, setBtnLoading] = useState(false);

  function useForceUpdate() {
    const [upd, setUpd] = useState(true);
    return () => setUpd(!upd);
  }

  const forceUpdate = useForceUpdate();

  function createDataAnualBudget(periodList, amtLastYear, amtThisYear, amtNextYear, currentYear) {
    const temp = [];
    periodList.forEach((i) => {
      temp.push({
        PeriodId: i.Id,
        Period: i.GlpNo,
        LastYear: DateToString(endOfMonth(addYears(new Date(i.GlpDate), -1))),
        LastYearAmt: amtLastYear,
        ThisYear: DateToString(endOfMonth(new Date(i.GlpDate))),
        ThisYearAmt: amtThisYear,
        NextYear: DateToString(endOfMonth(addYears(new Date(i.GlpDate), 1))),
        NextYearAmt: amtNextYear,
      });
    });

    return temp;
  }

  function createDataRevision(periodList, amtThisYear, rev1Amt, rev2Amt, rev3Amt, rev4Amt, currentYear) {
    const temp = [];
    periodList.forEach((i) => {
      temp.push({
        Period: i.GlpNo,
        ThisYearAmt: amtThisYear,
        ThisYear: DateToString(endOfMonth(new Date(i.GlpDate))),
        Revision1: rev1Amt,
        Revision2: rev2Amt,
        Revision3: rev3Amt,
        Revision4: rev4Amt,
      });
    });
    return temp;
  }

  const methods = useForm({ defaultValues: initData });
  const { handleSubmit, getValues } = methods;

  const disableFormEnter = (e) => {
    if (e.key === "Enter" && e.target.inputMode !== "numeric") e.preventDefault();
  };

  function AdjustAmtBeforeSave(data, keyName) {
    const obj = {};
    for (let i = 1; i < 13; i++) {
      obj[`Amt${i}`] = ToNumber(data[i - 1][keyName]);
    }
    return obj;
  }

  function AdjustRevisionBeforeSave(data, keyName) {
    const revision = {};
    for (let i = 1; i < 13; i++) {
      revision[`Amt${i}`] = ToNumber(data.length > 0 ? data[i - 1][keyName] : 0);
    }
    return revision;
  }

  const onSubmit = async () => {
    const values = getValues();
    setBtnLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 500));

    const newThisYearAmt = AdjustAmtBeforeSave(dataTab1, "ThisYearAmt");
    const newNextYearAmt = AdjustAmtBeforeSave(dataTab1, "NextYearAmt");
    let r1 = {};
    let r2 = {};
    let r3 = {};
    let r4 = {};

    r1 = AdjustRevisionBeforeSave(dataTab2, "Revision1");
    r1.Revision = initData.Revisions[0]?.Revision;
    r1.Caption = initData.Revisions[0]?.Caption;
    r2 = AdjustRevisionBeforeSave(dataTab2, "Revision2");
    r2.Revision = initData.Revisions[1]?.Revision;
    r2.Caption = initData.Revisions[1]?.Caption;
    r3 = AdjustRevisionBeforeSave(dataTab2, "Revision3");
    r3.Revision = initData.Revisions[2]?.Revision;
    r3.Caption = initData.Revisions[2]?.Caption;
    r4 = AdjustRevisionBeforeSave(dataTab2, "Revision4");
    r4.Revision = initData.Revisions[3]?.Revision;
    r4.Caption = initData.Revisions[3]?.Caption;

    //Adjust parameter before save
    setInitData(
      (state) => ({
        ...state,
        ThisYearAmt: newThisYearAmt,
        NextYearAmt: newNextYearAmt,
        Revisions: [r1, r2, r3, r4],
        ...values,
      }),
      (nextState) => {
        Save(nextState);
      }
    );
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);

    //Tab Revision
    if (newValue === 1) {
      for (let i = 0; i < dataTab2.length; i++) {
        dataTab2[i].ThisYearAmt = dataTab1[i].ThisYearAmt;
      }
      setDataTab2(dataTab2);
    }
  };

  const menuControlProp = [
    { name: "Back", fnc: () => redirect("list", basePath) },
    { name: "Add", disabled: true },
    { name: "Edit", disabled: true },
    { name: "Delete", disabled: true },
  ];

  const fetchDimListByModule = useCallback(async () => {
    const { Data } = await getActiveDimListByModuleName(10, 1, "BG");
    setInitData((state) => ({
      ...state,
      DimList: {
        Dim: Data,
      },
    }));
  }, []);

  const fetchYearList = useCallback(async () => {
    const thisYear = addDays(new Date(ClosePeriodGl), 1);
    const { Data } = await getYearListByYear(thisYear.getFullYear());
    const periodList = Data;

    setDataTab1(createDataAnualBudget(periodList, 0, 0, 0, thisYear.getFullYear()));
    setDataTab2(createDataRevision(periodList, 0, 0, 0, 0, 0, thisYear.getFullYear()));

    setInitData((state) => ({
      ...state,
      Year: thisYear.getFullYear(),
    }));
  });

  useEffect(() => {
    fetchDimListByModule();
    fetchYearList();
  }, [fetchDimListByModule]);

  const [openDim, setOpenDim] = useState(false);
  const [dataDim, setDataDim] = useStateWithCallbackLazy();

  const TextFieldNumber = ({ index, name, disabled, value, updateValue }) => {
    const isRevisionBudget = name.search("Revision");

    const updateAnnual = (e) => {
      updateValue(e.target.value);
      const newArr = dataTab1;
      newArr[index][`${name}`] = ToNumber(e.target.value);
      setDataTab1(newArr);
    };

    const updateRevision = (e) => {
      updateValue(e.target.value);
      const newArr = dataTab2;
      newArr[index][`${name}`] = ToNumber(e.target.value);
      setDataTab2(newArr);
    };

    const handleKeyPressAnnual = (e) => {
      if (e.key === "Enter") {
        const nextElement = document.getElementsByName(`${name}${index + 1}`);
        if (nextElement.length > 0) {
          nextElement[0].value = e.target.value;
          nextElement[0].focus();
          const newArr = dataTab1;
          newArr[index + 1][`${name}`] = ToNumber(e.target.value);
          setDataTab1(newArr);
        }
      }
    };

    const handleKeyPressRevision = (e) => {
      if (e.key === "Enter") {
        const nextElement = document.getElementsByName(`${name}${index + 1}`);
        if (nextElement.length > 0) {
          nextElement[0].value = ToNumber(e.target.value);
          nextElement[0].focus();
          const newArr = dataTab2;
          newArr[index + 1][`${name}`] = ToNumber(e.target.value);
          setDataTab2(newArr);
        }
      }
    };

    const handleFocus = (e) => {
      updateValue(e.target.value);
      e.target.select();
      setTimeout(function () {
        e.target.setSelectionRange(0, e.target.value.length);
      }, 0);
    };

    return (
      <NumberFormatInput
        style={{
          textAlign: "right",
          fontSize: 14,
          paddingRight: 4,
          margin: 6,
        }}
        name={name + index}
        value={value}
        onChange={isRevisionBudget === -1 ? updateAnnual : updateRevision}
        onFocus={handleFocus}
        onKeyPress={isRevisionBudget === -1 ? handleKeyPressAnnual : handleKeyPressRevision}
        disabled={disabled}
        decimal={SettingSystem.CurrencyBaseDecimal}
        decimalSep={SettingSystem.DecimalSeparator}
        thousandSep={SettingSystem.ThousandSeparator}
      />
    );
  };

  const showDialogChangeRevName = (revNo) => {
    setRevNo(revNo);
    setOpenDialogChangeRev(!openDialogChangeRev);
  };

  const columns = [
    {
      name: "Period",
      label: "Period",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "center",
          },
        }),
      },
    },
    {
      name: "LastYear",
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: () => `Year ${initData.Year - 1}`,
      },
    },
    {
      name: "LastYearAmt",
      label: " ",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customHeadLabelRender: () => (
          <Button
            variant="contained"
            onClick={() => {
              for (let i = 0; i < 12; i++) {
                dataTab1[i].ThisYearAmt = dataTab1[i].LastYearAmt;
              }
              setDataTab1(dataTab1, (_) => {});
              forceUpdate();
            }}
          >
            {"Copy To >>"}
          </Button>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          // const thisYear = addDays(new Date(ClosePeriodGl), 1);
          // const dateRow = StringToDate(tableMeta.tableData[tableMeta.rowIndex].LastYear);
          return (
            <TextFieldNumber
              index={tableMeta.rowIndex}
              name={tableMeta.columnData.name}
              value={value}
              updateValue={updateValue}
              disabled
            />
          );
        },
      },
    },
    {
      name: "ThisYear",
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: () => `Year ${initData.Year}`,
      },
    },
    {
      name: "ThisYearAmt",
      label: " ",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customHeadLabelRender: () => (
          <Button
            variant="contained"
            onClick={() => {
              for (let i = 0; i < 12; i++) {
                dataTab1[i].NextYearAmt = dataTab1[i].ThisYearAmt;
              }
              setDataTab1(dataTab1, (_) => {});
              forceUpdate();
            }}
          >
            {"Copy To >>"}
          </Button>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          const thisYear = addDays(new Date(ClosePeriodGl), 1);
          const dateRow = StringToDate(tableMeta.tableData[tableMeta.rowIndex].ThisYear);
          return (
            <TextFieldNumber
              index={tableMeta.rowIndex}
              name={tableMeta.columnData.name}
              value={value}
              updateValue={updateValue}
              disabled={thisYear > dateRow}
            />
          );
        },
      },
    },
    {
      name: "NextYear",
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: () => `Year ${parseInt(initData.Year) + 1}`,
      },
    },
    {
      name: "NextYearAmt",
      label: " ",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <TextFieldNumber
            index={tableMeta.rowIndex}
            name={tableMeta.columnData.name}
            value={value}
            updateValue={updateValue}
          />
        ),
      },
    },
  ];

  const columnsRevision = [
    {
      name: "Period",
      label: "Period",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "center",
          },
        }),
      },
    },
    {
      name: "ThisYear",
      label: "ThisYear",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "ThisYearAmt",
      label: " ",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <TextFieldNumber
            index={tableMeta.rowIndex}
            name={tableMeta.columnData.name}
            value={value}
            updateValue={updateValue}
            disabled={true}
          />
        ),
      },
    },
    {
      name: "Revision1",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customHeadLabelRender: () => {
          return (
            <div className={classes.flexRightSide}>
              <Typography variant="body2" display="inline">
                {initData.Revisions[0]?.Caption ?? "Revision1"}
              </Typography>
              <Tooltip title="Change Caption Revision">
                <EditIcon
                  fontSize="small"
                  style={{ cursor: "pointer", marginLeft: 10 }}
                  onClick={() => showDialogChangeRevName(0)}
                />
              </Tooltip>
            </div>
          );
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          const thisYear = addDays(new Date(ClosePeriodGl), 1);
          const dateRow = StringToDate(tableMeta.tableData[tableMeta.rowIndex].ThisYear);
          return (
            <TextFieldNumber
              index={tableMeta.rowIndex}
              name={tableMeta.columnData.name}
              value={value}
              updateValue={updateValue}
              disabled={thisYear > dateRow}
            />
          );
        },
      },
    },
    {
      name: "Revision2",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customHeadLabelRender: () => {
          return (
            <div className={classes.flexRightSide}>
              <Typography variant="body2" display="inline">
                {initData.Revisions[1]?.Caption ?? "Revision2"}
              </Typography>
              <Tooltip title="Change Caption Revision">
                <EditIcon
                  fontSize="small"
                  style={{ cursor: "pointer", marginLeft: 10 }}
                  onClick={() => showDialogChangeRevName(1)}
                />
              </Tooltip>
            </div>
          );
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          const thisYear = addDays(new Date(ClosePeriodGl), 1);
          const dateRow = StringToDate(tableMeta.tableData[tableMeta.rowIndex].ThisYear);
          return (
            <TextFieldNumber
              index={tableMeta.rowIndex}
              name={tableMeta.columnData.name}
              value={value}
              updateValue={updateValue}
              disabled={thisYear > dateRow}
            />
          );
        },
      },
    },
    {
      name: "Revision3",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customHeadLabelRender: () => {
          return (
            <div className={classes.flexRightSide}>
              <Typography variant="body2" display="inline">
                {initData.Revisions[2]?.Caption ?? "Revision3"}
              </Typography>
              <Tooltip title="Change Caption Revision">
                <EditIcon
                  fontSize="small"
                  style={{ cursor: "pointer", marginLeft: 10 }}
                  onClick={() => showDialogChangeRevName(2)}
                />
              </Tooltip>
            </div>
          );
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          const thisYear = addDays(new Date(ClosePeriodGl), 1);
          const dateRow = StringToDate(tableMeta.tableData[tableMeta.rowIndex].ThisYear);
          return (
            <TextFieldNumber
              index={tableMeta.rowIndex}
              name={tableMeta.columnData.name}
              value={value}
              updateValue={updateValue}
              disabled={thisYear > dateRow}
            />
          );
        },
      },
    },
    {
      name: "Revision4",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customHeadLabelRender: () => {
          return (
            <div className={classes.flexRightSide}>
              <Typography variant="body2" display="inline">
                {initData.Revisions[3]?.Caption ?? "Revision4"}
              </Typography>
              <Tooltip title="Change Caption Revision">
                <EditIcon
                  fontSize="small"
                  style={{ cursor: "pointer", marginLeft: 10 }}
                  onClick={() => showDialogChangeRevName(3)}
                />
              </Tooltip>
            </div>
          );
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          const thisYear = addDays(new Date(ClosePeriodGl), 1);
          const dateRow = StringToDate(tableMeta.tableData[tableMeta.rowIndex].ThisYear);
          return (
            <TextFieldNumber
              index={tableMeta.rowIndex}
              name={tableMeta.columnData.name}
              value={value}
              updateValue={updateValue}
              disabled={thisYear > dateRow}
            />
          );
        },
      },
    },
  ];

  const footerClasses = clsx({
    [classes.footerCell]: true,
    [classes.stickyFooterCell]: true,
  });

  const options = {
    responsive: "standard",
    selectableRows: "none",
    serverSide: true,
    fixedHeader: true,
    tableBodyHeight: "520px",
    search: false,
    download: false,
    filter: false,
    print: false,
    viewColumns: false,
    elevation: 0,
    setTableProps: () => {
      return {
        padding: "checkbox",
        size: "small",
      };
    },
    pagination: false,
    customTableBodyFooterRender: function (opts) {
      const sumLastYear = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[2].props.value);
        return NumberFormat(s ?? 0);
      }, 0);
      const sumThisYear = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[4].props.value);
        return NumberFormat(s ?? 0);
      }, 0);
      const sumNextYear = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[6].props.value);
        return NumberFormat(s ?? 0);
      }, 0);

      return (
        <TableFooter className={footerClasses}>
          <TableRow>
            {opts.columns.map((col) => {
              if (col.display === "true") {
                if (col.name === "LastYearAmt") {
                  return (
                    <TableCell key={col.name?.toString()} className={footerClasses}>
                      <span className={classes.pdrTextFooter}>{sumLastYear}</span>
                    </TableCell>
                  );
                } else if (col.name === "ThisYearAmt") {
                  return (
                    <TableCell key={col.name?.toString()} className={footerClasses}>
                      <span className={classes.pdrTextFooter}>{sumThisYear}</span>
                    </TableCell>
                  );
                } else if (col.name === "NextYearAmt") {
                  return (
                    <TableCell key={col.name?.toString()} className={footerClasses}>
                      <span className={classes.pdrTextFooter}>{sumNextYear}</span>
                    </TableCell>
                  );
                } else {
                  return <TableCell key={col.name?.toString()} className={footerClasses} />;
                }
              }
              return null;
            })}
          </TableRow>
        </TableFooter>
      );
    },
  };

  const optionsRevision = {
    responsive: "standard",
    selectableRows: "none",
    serverSide: true,
    fixedHeader: true,
    tableBodyHeight: "520px",
    search: false,
    download: false,
    filter: false,
    print: false,
    viewColumns: false,
    elevation: 0,
    setTableProps: () => {
      return {
        padding: "checkbox",
        size: "small",
      };
    },
    pagination: false,
    customTableBodyFooterRender: function (opts) {
      const sumThisYear = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[2].props.value);
        return NumberFormat(s ?? 0);
      }, 0);
      const sumRev1 = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[3].props.value);
        return NumberFormat(s ?? 0);
      }, 0);
      const sumRev2 = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[4].props.value);
        return NumberFormat(s ?? 0);
      }, 0);
      const sumRev3 = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[5].props.value);
        return NumberFormat(s ?? 0);
      }, 0);
      const sumRev4 = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[6].props.value);
        return NumberFormat(s ?? 0);
      }, 0);

      return (
        <TableFooter className={footerClasses}>
          <TableRow>
            {opts.columns.map((col, index) => {
              if (col.display === "true") {
                if (col.name === "ThisYearAmt") {
                  return (
                    <TableCell key={col.name?.toString()} className={footerClasses}>
                      <span className={classes.pdrTextFooter}>{sumThisYear}</span>
                    </TableCell>
                  );
                } else if (col.name === "Revision1") {
                  return (
                    <TableCell key={col.name?.toString()} className={footerClasses}>
                      <span className={classes.pdrTextFooter}>{sumRev1}</span>
                    </TableCell>
                  );
                } else if (col.name === "Revision2") {
                  return (
                    <TableCell key={col.name?.toString()} className={footerClasses}>
                      <span className={classes.pdrTextFooter}>{sumRev2}</span>
                    </TableCell>
                  );
                } else if (col.name === "Revision3") {
                  return (
                    <TableCell key={col.name?.toString()} className={footerClasses}>
                      <span className={classes.pdrTextFooter}>{sumRev3}</span>
                    </TableCell>
                  );
                } else if (col.name === "Revision4") {
                  return (
                    <TableCell key={col.name?.toString()} className={footerClasses}>
                      <span className={classes.pdrTextFooter}>{sumRev4}</span>
                    </TableCell>
                  );
                } else {
                  return <TableCell key={col.name?.toString()} className={footerClasses} />;
                }
              }
              return null;
            })}
          </TableRow>
        </TableFooter>
      );
    },
  };

  const Save = async (values) => {
    const sumThisYearAmt = Object.keys(values.ThisYearAmt).reduce(
      (sum, key) => sum + parseFloat(values.ThisYearAmt[key] || 0),
      0
    );

    const sumNextYearAmt = Object.keys(values.NextYearAmt).reduce(
      (sum, key) => sum + parseFloat(values.NextYearAmt[key] || 0),
      0
    );

    if (sumThisYearAmt !== 0) {
      const modelCurrent = {
        Year: values.Year,
        DeptCode: values.DeptCode,
        AccCode: values.AccCode,
        ThisYearAmt: values.ThisYearAmt,
        Revisions: values.Revisions,
        DimList: values.DimList,
        UserModified: values.UserModified,
      };
      const { Code, UserMessage, InternalMessage } = await createBudgetDetail(modelCurrent);
      if (Code === 0) {
        //save nextyearamt
        if (sumNextYearAmt !== 0) {
          const modelNextYear = {
            Year: values.Year + 1,
            DeptCode: values.DeptCode,
            AccCode: values.AccCode,
            ThisYearAmt: values.NextYearAmt,
            Revisions: values.Revisions,
            DimList: values.DimList,
            UserModified: values.UserModified,
          };
          const { Code } = await createBudgetDetail(modelNextYear);
          if (Code === 0) {
            SnackbarUtils.success(UserMessage, function () {
              redirect(`${InternalMessage}/show`);
            });
          }
        } else {
          SnackbarUtils.success(UserMessage, function () {
            redirect(`${InternalMessage}/show`);
          });
        }
        setBtnLoading(false);
      } else {
        setBtnLoading(false);
        if (InternalMessage) {
          SnackbarUtils.error(InternalMessage);
        } else {
          SnackbarUtils.warning(UserMessage);
        }
      }
    } else {
      setBtnLoading(false);
    }

    if (sumThisYearAmt === 0 && sumNextYearAmt > 0) {
      //save nextyearamt
      if (sumNextYearAmt !== 0) {
        const modelNextYear = {
          Year: values.Year + 1,
          DeptCode: values.DeptCode,
          AccCode: values.AccCode,
          ThisYearAmt: values.NextYearAmt,
          Revisions: values.Revisions,
          DimList: values.DimList,
          UserModified: values.UserModified,
        };
        const { Code, UserMessage, InternalMessage } = await createBudgetDetail(modelNextYear);
        if (Code === 0) {
          SnackbarUtils.success(UserMessage, function () {
            redirect(`${InternalMessage}/show`);
          });
        } else {
          SnackbarUtils.success(UserMessage, function () {
            redirect(`${InternalMessage}/show`);
          });
        }
      }
    } else {
      setBtnLoading(false);
    }

    if (sumThisYearAmt === 0 && sumNextYearAmt === 0) {
      const modelCurrent = {
        Year: values.Year,
        DeptCode: values.DeptCode,
        AccCode: values.AccCode,
        ThisYearAmt: 0,
        Revisions: values.Revisions,
        DimList: values.DimList,
        UserModified: values.UserModified,
      };
      const { Code, UserMessage, InternalMessage } = await createBudgetDetail(modelCurrent);
      if (Code === 0) {
        SnackbarUtils.success(UserMessage, function () {
          redirect(`${InternalMessage}/show`);
        });
      }
    }
  };

  const ShowDim = (values) => {
    if (!values) {
      setDataDim(initData.DimList.Dim);
      setOpenDim(!openDim);
    }
  };

  const CancelFnc = () => {
    redirect("list", basePath);
  };

  return (
    <div
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: openDim,
        [classes.drawerClose]: !openDim,
      })}
    >
      <ActionMenu menuControl={menuControlProp} />

      <Paper className={classes.root}>
        <BoxHeader header={"Budget"} />
        <form onKeyDown={disableFormEnter}>
          <Grid container alignItems="flex-start" spacing={1} style={{ marginBottom: 2 }}>
            <Grid item xs={2}>
              <Typography variant="body2">Year</Typography>
              <Typography variant="body1">{initData.Year}</Typography>
            </Grid>
            {formFields
              ? formFields.map((item) => (
                  <Grid item xs={item.size} key={item.field.props.name?.toString()}>
                    {React.createElement(item.field.type, {
                      ...{
                        ...item.field.props,
                        methods,
                        key: item.field.props.name,
                      },
                    })}
                  </Grid>
                ))
              : ""}
          </Grid>
        </form>
        {initData.DimList?.Dim.length > 0 && <Divider />}
        {initData.DimList?.Dim.length > 0 && (
          <Box>
            <BoxHeader header={"Dimension"} />
            <Grid container alignItems="flex-start" spacing={1}>
              {/* <Grid item xs={2} style={{ marginLeft: 20 }}></Grid> */}
              <Grid item xs={2} />
              <Grid item xs={8}>
                <DimensionContent
                  width={200}
                  typeOfFlex={"row"}
                  data={initData.DimList?.Dim}
                  update={(item, value) => {
                    const DimListDetail = initData?.DimList?.Dim;
                    [...DimListDetail].forEach((i) => {
                      if (i.Id === item.Id) {
                        i.Value = value;
                        if (i.Type === "Date") {
                          i.Value = DateToString(value);
                        }
                      }
                    });
                    const Dim = {
                      Dim: DimListDetail,
                    };
                    setInitData((state) => ({
                      ...state,
                      DimList: Dim,
                    }));
                  }}
                  modify={true}
                />
              </Grid>
            </Grid>
          </Box>
        )}
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          style={{
            marginBottom: 12,
            border: "1px solid #e0e0e3",
            borderRadius: "10px",
          }}
        >
          <StyledTab label={translate("ra.field.Annual Budget")} {...a11yProps(0)} />
          <StyledTab label={translate("ra.field.Revision Budget")} {...a11yProps(1)} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <MUIDataTable data={dataTab1} columns={columns} options={options} />
          <br />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <MUIDataTable data={dataTab2} columns={columnsRevision} options={optionsRevision} />
        </TabPanel>
        <ButtonFooter disabled={isBtnLoading} SaveFnc={handleSubmit(onSubmit)} CancelFnc={CancelFnc} />
      </Paper>
      {initData?.Revisions && showDialogChangeRevName && (
        <DialogChangeRevision
          value={initData?.Revisions?.[revNo]?.Caption}
          open={openDialogChangeRev}
          close={() => setOpenDialogChangeRev(false)}
          save={(newCaption) => {
            initData.Revisions.forEach((item, idx) => {
              if (idx === revNo) {
                item.Caption = newCaption;
              }
            });
            setInitData((state) => ({
              ...state,
              Revisions: initData.Revisions,
            }));
            setOpenDialogChangeRev(false);
          }}
        />
      )}
      <pre>{process.env.NODE_ENV === "development" ? JSON.stringify(initData, 0, 2) : ""}</pre>
      <NavRight open={openDim} close={() => setOpenDim(false)} ShowDim={() => ShowDim()} dataDim={dataDim} />
    </div>
  );
};

export default Create;
